import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useGetFestivalOffer } from "../home/api/api";
const DashboardAd = () => {

   
   const { data: getBanner } = useGetFestivalOffer({ type: "dashboard" });

   const allBanners = Array.isArray(getBanner?.data) ? getBanner.data : [];
 
   const activeBanners = allBanners?.filter((b) => b?.isActive === true);
 
   if (activeBanners.length === 0) return null;
 
   const settings = {
     dots: activeBanners.length > 1,
     infinite: activeBanners.length > 1,
     speed: 500,
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false,
     autoplay: activeBanners.length > 1,
     autoplaySpeed: 1500,
   };
   return (

      <div className="dbPgAd">
      <Slider {...settings}>
        {activeBanners.map((banner) => (
          <div className="dbPgAdIg" key={banner._id}>
            <img
              src={banner?.imageUrl}
              alt={banner.festivalName || "dashboard-ad"}
              className="img-fluid d-none d-md-inline-block"
            />

            <img
              src={banner?.MobileUrl}
              alt={banner.festivalName || "dashboard-ad"}
              className="img-fluid d-md-none"
            />

          </div>
        ))}
      </Slider>
    </div>
   )
}
export default DashboardAd;